import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, vModelCheckbox as _vModelCheckbox, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, vShow as _vShow, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { id: "popup-header-message" }
const _hoisted_2 = { id: "check-box" }
const _hoisted_3 = { class: "button-container" }
const _hoisted_4 = { class: "status-message" }
const _hoisted_5 = { class: "button-container" }
const _hoisted_6 = { class: "status-message" }
const _hoisted_7 = { class: "button-container" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_offer_button = _resolveComponent("offer-button")!

  return (_openBlock(), _createElementBlock("div", {
    id: "overlay",
    onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.closePopup()))
  }, [
    _createElementVNode("div", {
      id: "popup",
      onClick: _cache[6] || (_cache[6] = _withModifiers(() => {}, ["stop"]))
    }, [
      _withDirectives(_createElementVNode("div", null, [
        _createElementVNode("div", _hoisted_1, _toDisplayString(_ctx.message), 1 /* TEXT */),
        _createElementVNode("div", _hoisted_2, [
          _withDirectives(_createElementVNode("input", {
            type: "checkbox",
            name: "check",
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.acceptChecked) = $event))
          }, null, 512 /* NEED_PATCH */), [
            [_vModelCheckbox, _ctx.acceptChecked]
          ]),
          (_ctx.isAcceptPopup)
            ? (_openBlock(), _createElementBlock("label", {
                key: 0,
                for: "check",
                onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.acceptChecked = !_ctx.acceptChecked))
              }, _toDisplayString(_ctx.wishToAcceptOffer), 1 /* TEXT */))
            : (_openBlock(), _createElementBlock("label", {
                key: 1,
                onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.acceptChecked = !_ctx.acceptChecked))
              }, _toDisplayString(_ctx.wishToRejectOffer), 1 /* TEXT */))
        ]),
        _createElementVNode("div", _hoisted_3, [
          _createVNode(_component_offer_button, {
            id: "btn-accept",
            text: _ctx.btnText,
            enabled: _ctx.acceptChecked,
            color: "var(--green)",
            onClick: _ctx.onConfirmedClick
          }, null, 8 /* PROPS */, ["text", "enabled", "onClick"]),
          _createVNode(_component_offer_button, {
            id: "btn-reject",
            text: _ctx.cancel,
            color: "var(--red)",
            onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.closePopup()))
          }, null, 8 /* PROPS */, ["text"])
        ])
      ], 512 /* NEED_PATCH */), [
        [_vShow, _ctx.confirmStatus === _ctx.ConfirmStatus.none]
      ]),
      _withDirectives(_createElementVNode("div", null, [...(_cache[8] || (_cache[8] = [
        _createElementVNode("div", { class: "spinner" }, null, -1 /* CACHED */)
      ]))], 512 /* NEED_PATCH */), [
        [_vShow, _ctx.confirmStatus === _ctx.ConfirmStatus.confirming]
      ]),
      _withDirectives(_createElementVNode("div", null, [
        _createElementVNode("span", _hoisted_4, _toDisplayString(_ctx.acceptOrRejectOfferConfirmed), 1 /* TEXT */),
        _createElementVNode("div", _hoisted_5, [
          _createVNode(_component_offer_button, {
            id: "btn-close",
            text: _ctx.closeConfirmedOrErrorMessage,
            color: "var(--green)",
            onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.closePopup()))
          }, null, 8 /* PROPS */, ["text"])
        ])
      ], 512 /* NEED_PATCH */), [
        [_vShow, _ctx.confirmStatus === _ctx.ConfirmStatus.success]
      ]),
      _withDirectives(_createElementVNode("div", null, [
        _createElementVNode("span", _hoisted_6, _toDisplayString(_ctx.acceptOrRejectOfferError), 1 /* TEXT */),
        _createElementVNode("div", _hoisted_7, [
          _createVNode(_component_offer_button, {
            text: _ctx.closeConfirmedOrErrorMessage,
            color: "var(--red)",
            onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.closePopup()))
          }, null, 8 /* PROPS */, ["text"])
        ])
      ], 512 /* NEED_PATCH */), [
        [_vShow, _ctx.confirmStatus === _ctx.ConfirmStatus.fail]
      ])
    ])
  ]))
}